/** @format */
import { _$, Dialog, Input, Message } from '@king-design/react'
import React, { FC, useState } from 'react'
import { useAsyncFn } from 'react-use'
import { applyWorkflow, stopSceneRecord } from 'src/api/ApiEventOpsRecord'

export type RemarkDialogAction = 'approve' | 'stop'

interface RemarkDialogProps {
  visible: boolean
  type: RemarkDialogAction
  params?: { [key: string]: string | number }
  onClose: (update: boolean) => void
}
const RemarkDialog: FC<RemarkDialogProps> = ({ visible, params, type, onClose }) => {
  const [remark, setRemark] = useState('') // 备注信息

  const [, fetchStop] = useAsyncFn(async () => {
    const result =
      type === 'stop'
        ? await stopSceneRecord({ RecordID: params.SceneRecordID, Remark: remark })
        : await applyWorkflow({ ...params, Remark: remark })
    if (result) {
      Message.success(_$('操作成功'))
      onClose(true)
    }
  }, [params, type, remark])

  return (
    <Dialog
      value={visible}
      width={648}
      onChangeValue={show => {
        !show && onClose(false)
      }}
      ok={() => {
        fetchStop()
      }}
      title={_$('备注')}
    >
      <Input
        width={600}
        value={remark}
        type="textarea"
        onChangeValue={value => setRemark(value)}
        rows={4}
        placeholder={_$('请输入备注信息')}
      />
    </Dialog>
  )
}
export default RemarkDialog
